//import { minMaxAvg as arrayMinMaxAvg } from '../../ixfx/src/numbers-compute.js';
import { defaultComparer } from './comparers.js';
const sorterByValueIndex = (index, reverse = false) => {
    return (values) => {
        const s = values.toSorted((a, b) => {
            return defaultComparer(a[index], b[index]);
        });
        if (reverse)
            return s.reverse();
        return s;
    };
};
export const keyValueSorter = (sortStyle) => {
    switch (sortStyle) {
        case `value`: {
            return sorterByValueIndex(1, false);
        }
        case `value-reverse`: {
            return sorterByValueIndex(1, true);
        }
        case `key`: {
            return sorterByValueIndex(0, false);
        }
        case `key-reverse`: {
            return sorterByValueIndex(0, true);
        }
        default: {
            throw new Error(`Unknown sorting value '${sortStyle}'. Expecting: value, value-reverse, key or key-reverse`);
        }
    }
};
// export const minMaxAvg = (entries: readonly KeyValue[], conversionFunction?: (v: KeyValue) => number) => {
//   const converter = conversionFunction ?? ((v: KeyValue) => v[ 1 ] as number);
//   const values = entries.map<number>(entry => converter(entry));
//   return arrayMinMaxAvg(values);
// };
